import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import { NotificationStyles } from './styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import NotNotification from '../../../assets/img/not-notifications.png';
import { v4 as uuidv4 } from 'uuid';
import { useHistory } from "react-router-dom";

export default function Notification() {
    const [anchorEl, setAnchorEl] = useState(null);
    const [notificacao, setNotificacao] = useState([]);

    let history = useHistory();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleRedirecionaCaixa = (url) => {
        setAnchorEl(null);
        history.push(url);
    }

    return (
        <NotificationStyles id="NotificationStyles">
            <IconButton className="txt-primario icon-button-notification" component="span" aria-controls="userdata-menu" aria-haspopup="true" onClick={handleClick}>
                {!!notificacao.length && (
                    <NotificationStyles.Mark id="Notification_Mark" />
                )}

                <NotificationsNoneIcon />
            </IconButton>
            <Menu
                id="notification-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}>
                <MenuItem className="title-view-all-notifications">Notificações</MenuItem>
                <NotificationStyles.MenuItemList className="content-subitem-menu-notifications">
                    <NotificationStyles.Menu id="Notification_Menu">
                        {
                            notificacao.length === 0
                                ?
                                <NotificationStyles.MenuItem id="Notification_MenuItem" style={{ height: '163px' }}>
                                    <NotificationStyles.NoMessage id="Notification_NoMessage">
                                        <img src={NotNotification} alt="" />
                                        Não ha nenhuma<br />notificação no momento
                                    </NotificationStyles.NoMessage>
                                </NotificationStyles.MenuItem>
                                :
                                notificacao.map(notifica => (
                                    <NotificationStyles.MenuItem key={uuidv4()} id="Notification_MenuItem" className="waves-effect waves-blue-light" onClick={() => handleRedirecionaCaixa(notifica.url)}>
                                        <NotificationStyles.MenuItemIcon id="Notification_MenuItemIcon"><NotificationsNoneIcon /></NotificationStyles.MenuItemIcon>
                                        <NotificationStyles.Info>
                                            <NotificationStyles.MenuItemTitle id="Notification_MenuItemTitle">{notifica.descricao}</NotificationStyles.MenuItemTitle>
                                        </NotificationStyles.Info>
                                    </NotificationStyles.MenuItem>
                                ))
                        }
                    </NotificationStyles.Menu>
                </NotificationStyles.MenuItemList>
                <MenuItem onClick={() => setAnchorEl(null)} className="btn-view-all-notifications">Fechar</MenuItem>
            </Menu>
        </NotificationStyles >
    )
}